module.exports = __webpack_public_path__ + "static/media/menu-feed.e6bcf19c.svg";